import {
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  VStack,
  Skeleton,
  SkeletonText,
  SkeletonCircle,
} from "@chakra-ui/react";

const ProductDetailSkeleton = () => {
  return (
    <Grid
      templateColumns="repeat(14, 1fr)"
      gap={{ base: 0, md: "20px", lg: "32px", xl: "20px", "2xl": "32px" }}
      px={{
        base: "12px",
        sm: "24px",
        md: "32px",
        lg: "40px",
        xl: "48px",
        "2xl": 0,
      }}
    >
      {/* Product Images Skeleton (7/14) */}
      <GridItem colSpan={{ base: 14, md: 8, lg: 8, xl: 7 }}>
        <Skeleton w="full" h="400px" rounded="8px" />

        {/* Thumbnail Navigation Skeleton */}
        <Grid
          mt={{ base: "12px", lg: "24px" }}
          templateColumns="repeat(5, minmax(75px, 100px))"
          gap="16px"
          overflowX="auto"
        >
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} h="75px" maxW="100px" rounded="8px" />
          ))}
        </Grid>
      </GridItem>

      {/* Product Data Skeleton (4/14) */}
      <GridItem colSpan={{ base: 14, md: 6, xl: 4 }}>
        {/* Product Name and Price */}
        <SkeletonText
          noOfLines={1}
          spacing="4"
          skeletonHeight="20px"
          mt="24px"
        />
        <SkeletonText
          noOfLines={1}
          spacing="4"
          skeletonHeight="28px"
          mt="8px"
        />

        {/* Variants */}
        <Box mt="20px">
          <SkeletonText noOfLines={1} spacing="4" skeletonHeight="20px" />
          <HStack spacing={4} mt="12px">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} h="30px" w="75px" rounded="4px" />
            ))}
          </HStack>
        </Box>

        {/* Product Details */}
        <Box mt="20px" borderBottom="solid 1px #F2F3F5" pb="20px">
          <SkeletonText noOfLines={1} spacing="4" skeletonHeight="20px" />
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonText
              key={index}
              noOfLines={1}
              spacing="4"
              skeletonHeight="16px"
              mt="4px"
            />
          ))}
        </Box>

        {/* Reseller Profile */}
        <HStack
          mt="30px"
          spacing="8px"
          align="center"
          borderBottom="solid 1px #F2F3F5"
          pb="30px"
        >
          <SkeletonCircle size="60px" />
          <SkeletonText noOfLines={1} skeletonHeight="20px" w="200px" />
        </HStack>

        {/* Delivery */}
        <Box mt="30px" borderBottom="solid 1px #F2F3F5" pb="20px">
          <SkeletonText noOfLines={1} skeletonHeight="20px" />
          {Array.from({ length: 3 }).map((_, index) => (
            <HStack key={index} mt="8px" alignItems="center">
              <SkeletonCircle size="20px" />
              <SkeletonText noOfLines={1} skeletonHeight="16px" w="150px" />
            </HStack>
          ))}
        </Box>
      </GridItem>

      {/* Action to Buy Skeleton */}
      <GridItem display={{ base: "none", xl: "block" }} colSpan={3}>
        <Box border="solid 1px lightGray" rounded="16px" p="24px">
          {/* Quantity and Subtotal Section */}
          <VStack alignItems="start" spacing={4}>
            <SkeletonText noOfLines={1} skeletonHeight="20px" />
            <HStack alignItems="center">
              <Skeleton w="30px" h="30px" />
              <Skeleton w="35px" h="20px" />
              <Skeleton w="30px" h="30px" />
            </HStack>
            <SkeletonText noOfLines={1} skeletonHeight="20px" />
          </VStack>

          {/* Button Actions Section */}
          <VStack mt={6} spacing={4}>
            <Skeleton h="40px" w="full" />
            <Skeleton h="40px" w="full" />
          </VStack>
        </Box>
      </GridItem>
    </Grid>
  );
};

export default ProductDetailSkeleton;
